export default function EditTrainingPresentationDirective() {
  return {
    template: require('./edit-presentation.directive.html'),
    scope: {
      newMediaInputs: '=',
      topic: '=',
      section: '=',
      media: '=',
    },
    controller: 'EditTrainingPresentationDirectiveController',
    controllerAs: 'editTrainingPresentationVM',
    bindToController: true,
    replace: true,
  };
}
